export const colors = [
  "rgba(170, 68, 153, 0.75)",
  "rgba(136, 204, 238, 0.75)",
  "rgba(221, 204, 119, 0.75)",
]
